import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa'

const SavedMessage = ({message}) => {
  return (
    <div className="save-message">
          <FaRegCheckCircle className="check-circle" />
          <span className="save-message-text">{message}</span>
        </div>
  );
};

export default React.memo(SavedMessage);
